// add reducer files here
export { default as User } from './User';
export { default as users } from './users';
export { default as patients } from './patients';
export { default as patient_records } from './patient_records';
export { default as sessions } from './sessions';
export { default as notifications } from './notifications';

export { default as assessments } from './assessments';
export { default as app } from './app';
export { default as modal } from './modal';

export { default as toasts } from './toasts';
export { default as therapy_areas } from './therapy_areas';
export { default as therapy_categories } from './therapy_categories';
export { default as practice_types } from './practice_type';

export { default as videos } from './videos';
export { default as practices } from './practices';
export { default as media_upload } from './media_upload';
export { default as gallery } from './gallery';



// WEBPACK FOOTER //
// ./src/reducers/index.js